module.exports = __webpack_public_path__ + "static/img/Quest.dd307ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icon/Quest.jpg
// module id = fWTP
// module chunks = 2